import { gql, useQuery } from '@apollo/client'
import { useEffect } from 'react'

import {
  StoreItemPurchaseCompleteQuery,
  StoreItemPurchaseCompleteQueryVariables,
  UserCartTransactionOrderFragmentDoc,
} from '@/clients/utoniq-core/schema'
import { makeViewModel } from '@/core/architecture'
import { removeStoreProceed } from '@/core/native/storage'
import { useRouter } from '@/core/router'

import { Action, State } from './template'

/**
 *
 */
export const useViewModel = makeViewModel<State, Action>(() => {
  const { router } = useRouter<{
    cartTransactionOrderId?: string
    artistId?: string
    itemId?: string
  }>()
  const cartTransactionOrderId = router.query.cartTransactionOrderId
  const { data, loading } = useQuery<
    StoreItemPurchaseCompleteQuery,
    StoreItemPurchaseCompleteQueryVariables
  >(QUERY, {
    skip: !cartTransactionOrderId,
    variables: {
      userCartTransactionOrderId: cartTransactionOrderId ?? '#',
    },
  })

  useEffect(() => {
    removeStoreProceed()
  }, [])

  return {
    state: {
      loading,
      isKonbini: !!data?.userCartTransactionOrder.isKonbini,
      purchaseOrderId: data?.userCartTransactionOrder.id ?? '',
      paymentType: data?.userCartTransactionOrder.paymentType ?? null,
      voucherUrl:
        data?.userCartTransactionOrder.pendingPurchaseItem?.voucherUrl ?? null,
      paymentDeadline:
        data?.userCartTransactionOrder.pendingPurchaseItem
          ?.formattedExpiredAt ?? null,
      itemId: router.query.itemId ?? '',
      pendingPurchaseItemId:
        data?.userCartTransactionOrder.pendingPurchaseItem?.id ?? '',
    },
    actions: {},
  }
})

const QUERY = gql`
  query StoreItemPurchaseComplete($userCartTransactionOrderId: ID!) {
    userCartTransactionOrder(id: $userCartTransactionOrderId) {
      ...UserCartTransactionOrder
    }
  }
  ${UserCartTransactionOrderFragmentDoc}
`
